import { render } from "./show.vue?vue&type=template&id=90fb2462"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/topic/show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "90fb2462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('90fb2462', __exports__)) {
    console.log('reload')
    api.reload('90fb2462', __exports__)
  }
  
  module.hot.accept("./show.vue?vue&type=template&id=90fb2462", () => {
    console.log('re-render')
    api.rerender('90fb2462', render)
  })

}


export default __exports__